import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fs-smaller grey1-grey1-color" }
const _hoisted_2 = { class: "fw-b" }
const _hoisted_3 = { class: "fs-smaller grey1-grey1-color" }
const _hoisted_4 = { class: "fw-b" }
const _hoisted_5 = {
  key: 1,
  class: "fw-b max-size"
}
const _hoisted_6 = { class: "fs-smaller grey1-grey1-color" }
const _hoisted_7 = { style: {"margin-top":"0.5rem"} }

import { IonCol, IonRow } from "@ionic/vue";

import { convertNumberWithComma } from "@/functions/converter";

import { CURRENCY_EUR } from "@/assets/variables";

import { ListItem } from "@/types/supplier";


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderItem',
  props: {
    entry: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.entry && __props.entry.item)
      ? (_openBlock(), _createBlock(_unref(IonRow), {
          key: 0,
          class: "remove-col-x-padding"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), { class: "fw-b" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.entry.item.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(IonCol), { size: "auto" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.entry.item.packaging), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.entry && __props.entry.item)
      ? (_openBlock(), _createBlock(_unref(IonRow), {
          key: 1,
          class: "stacked-cols remove-col-x-padding"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), {
              size: "auto",
              class: "fixed-width-xxs-screen"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('object.amount')), 1),
                _createElementVNode("div", _hoisted_2, _toDisplayString(__props.entry.quantity), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(IonCol), null, {
              default: _withCtx(() => [
                (Number(__props.entry.item.price))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('object.price')), 1),
                      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(convertNumberWithComma)(Number(__props.entry.item.price).toFixed(3))) + " " + _toDisplayString(_unref(CURRENCY_EUR)), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_unref(IonCol), {
              size: "4",
              class: "ion-text-end"
            }, {
              default: _withCtx(() => [
                (!Number((__props.entry.item.price ?? 0) * __props.entry.quantity))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('object.totalPosition')), 1),
                      _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(convertNumberWithComma)(Number((__props.entry.item.price ?? 0) * __props.entry.quantity).toFixed(3))) + " " + _toDisplayString(_unref(CURRENCY_EUR)), 1)
                    ]))
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})